import React from 'react';
import styled from 'styled-components';
import {
  color, typography, layout, space, border,
} from 'styled-system';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { ShowIf } from '../index';

const SText = styled.div(
  {
    display: 'inline-block',
  },
  color,
  typography,
  layout,
  space,
  border,
);
SText.defaultProps = {
  fontSize: 14,
};

export default function Text({
  translationId, children, upperCase, lowerCase, ...rest
}) {
  return (
    <SText {...rest}>
      <ShowIf condition={!upperCase && !lowerCase}>
        { translationId ? <FormattedMessage id={translationId} defaultMessage={children} /> : null}
        { !translationId ? children : null }
      </ShowIf>
      <ShowIf condition={upperCase}>
        <span style={{ textTransform: 'uppercase' }}>
          { translationId ? <FormattedMessage id={translationId} defaultMessage={children} /> : null}
          { !translationId ? children : null }
        </span>
      </ShowIf>
      <ShowIf condition={lowerCase}>
        <span style={{ textTransform: 'lowercase' }}>
          { translationId ? <FormattedMessage id={translationId} defaultMessage={children} /> : null}
          { !translationId ? children : null }
        </span>
      </ShowIf>
    </SText>
  );
}

Text.propTypes = {
  translationId: PropTypes.string,
  children: PropTypes.node,
  upperCase: PropTypes.bool,
  lowerCase: PropTypes.bool,
};

Text.defaultProps = {
  translationId: null,
  children: '',
  upperCase: false,
  lowerCase: false,
};
